import { render } from "./Edit.vue?vue&type=template&id=fa29e0f0&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=fa29e0f0&scoped=true&lang=css"
import "./Edit.vue?vue&type=style&index=1&id=fa29e0f0&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa29e0f0"]])

export default __exports__